/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IFooterViewProps } from '@msdyn365-commerce-modules/footer';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

//mmx-feature: svg support --start
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IFooterItemProps } from '../definition-extensions/footer-item.ext.props.autogenerated';
//mmx-feature: svg support --end

/**
 *
 * FooterItemView component.
 * @extends {React.PureComponent<IFooterViewProps>}
 */
//mmx-feature: svg support --start
/*
export class FooterItemView extends React.PureComponent<IFooterViewProps> {
*/
export class FooterItemView extends React.PureComponent<IFooterViewProps & IFooterItemProps<{}>> {
    //mmx-feature: svg support --end
    public render(): JSX.Element | null {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- Cannot change the prop names as props are from business logic.
        const { FooterItem } = this.props;
        return <Module {...FooterItem}>{this._renderElement(this.props)}</Module>;
    }

    //mmx-feature: svg support --start
    /*
    private _renderElement(props: IFooterViewProps): React.ReactNode | null {
    */
    private _renderElement(props: IFooterViewProps & IFooterItemProps<{}>): React.ReactNode | null {
        //mmx-feature: svg support --end
        // eslint-disable-next-line @typescript-eslint/naming-convention -- Cannot change the prop names as props are from business logic.
        const { heading, HeadingContainer, Link, linkText, image, text, EditableLink } = props;
        //mmx-feature: svg support --start
        let img = undefined;
        if (!this.props.config.imageSrc || this.props.config.imageSrc === "image") {
            img = image;
        }
        else if (this.props.config.imageSrc === "linkUrl" && props.config.imageSrc) {
            img = <Msdyn365.Image
                src={props.config.linkUrl?.destinationUrl}
                href={props.config.linkUrl?.destinationUrl}
                requestContext={this.props.context.request}
                className='mmx-footer-logo__svg'
                gridSettings={this.props.context.request.gridSettings!}
                imageSettings={{
                    viewports: {
                        xs: { q: 'w=24&h=24&m=6', w: 0, h: 0 },
                        lg: { q: 'w=24&h=24&m=6', w: 0, h: 0 }
                    },
                    lazyload: true
                }}
                loadFailureBehavior='default'
                editProps={{ key: this.props.config.image || {}, requestContext: this.props.context.request }}
                shouldSkipToMainImage
            />
        }
        //mmx-feature: svg support --end
        if (heading) {
            return (
                <Node {...HeadingContainer}>
                    {' '}
                    <Node tag='i' className='ms-footer__heading__title-icon' aria-hidden='true' />
                    {heading}{' '}
                </Node>
            );
        //mmx-feature: svg support --start
        /*
        } else if (Link && image) {
        */
        } else if (Link && img) {
        //mmx-feature: svg support --end
            return (
                <Node {...Link}>
                    {linkText}
                    {/*mmx-feature: svg support --start
                    {image}
                    */
                    img
                    /*mmx-feature: svg support --end*/}
                </Node>
            );
        } else if (Link) {
            return EditableLink;
        }
        return (
            <>
                {text}
                {/*mmx-feature: svg support --start
                {image}
                */
                img
                /*mmx-feature: svg support --start*/}
            </>
        );
    }
}

export default FooterItemView;
